import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './css/CenterProgress.scss';

export const CenterProgress = ({ style }) => {
	return (
		<div className={styles.progress} style={style}>
			<CircularProgress />
		</div>
	);
};
